<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<p class="dedi">This book is dedicated to the segregated soldiers of the tank destroyer branch. Not all of them fought in combat, but all of them helped the Allies to win the Second World War.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?7db3a02d